import { render, staticRenderFns } from "./CardHolders.vue?vue&type=template&id=e79ae33a"
import script from "./CardHolders.vue?vue&type=script&lang=js"
export * from "./CardHolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports